import React from "react";
import { observer } from "mobx-react";
import { FacilityOrderNewFlowBillingPreviewTemplate } from "themes/application/facility-order-new-flow-billing/pages";
import { FacilityOrderNewFlowBillingPreviewViewStore } from "application/facility-order-new-flow-billing/stores";
import { setCurrentView } from "core/utils";

@setCurrentView(rootStore => new FacilityOrderNewFlowBillingPreviewViewStore(rootStore), "facilityOrderNewFlowBillingPreviewViewStore")
@observer
class FacilityOrderNewFlowBillingPreview extends React.Component {
	render() {
		return <FacilityOrderNewFlowBillingPreviewTemplate {...this.props} />;
	}
}

export default FacilityOrderNewFlowBillingPreview;